<template>
<Modal v-if="wasClick" v-model="isModalShown"
    title=""
    wrapper-class="animate__animated"
    modal-class="room-modal"
    in-class="animate__zoomIn hideScroll"
    out-class="animate__zoomOut hideScroll">
    <div class="room-modal__header room-modal-header">
        <ModalTitle @close="isModalShown = false">
            {{ props.CabinSet.name }}{{ props.CabinSet.decks.length ? ', ' + props.CabinSet.decks[0].name?.toLowerCase() : '' }}
        </ModalTitle>
    </div>
    <div class="room-modal__content">
        <div class="room-modal__description room-modal-description">
            <div class="room-modal-description__header">
                <p class="room-modal-description__name">Каюта {{props.Cabin.name}}</p>
                <p class="room-modal-description__status" :class="{ '_booked': isBooked() }">{{ isBooked() ? 'Выбрана' : 'Свободна' }}</p>
            </div>

            <MySlider class="room-modal-description__slider" :slideRatio="200 / 300" :convertCdn="true"
                :slides="props.CabinSet.photos" srcKey="src" idKey="key"
            />

            <div class="room-modal-description__points">
                <div class="room-modal-description__point-element">
                    <vRooms class="boat-navigation__icon" />
                    <span>{{ accText }}</span>
                </div>
            </div>

            <InsertHtml class="room-modal-description__info" :html="props.CabinSet.description" link="pdf"/>

        </div>

        <div class="room-modal__order room-modal-order">
            <div class="room-modal-order__info">
                <div class="room-modal-order__title">Туристы</div>
                <div class="room-modal-order__text">
                    Выберите размещение в каюте
                </div>

            </div>

            <div v-if="occupation" class="room-modal-order__tourists">

                <label class="custom-radio" v-for="opt in occupation.list"  :key="opt.adultChild">
                    <input
                        type="radio"
                        name="occupation_list"
                        :value="opt.adultChild"
                        v-model="occrec"
                  >
                    {{vzros(opt.adult)}}
                    <span v-if="opt.child" >
                        + {{rebenok(opt.child)}}
                        (<SinceTill :agesLine="occupation.ages.child" />)
                    </span>
                </label>

                <MyCheckbox v-if="occupation.ages.infant.till" :choosed="infant_str" @input="set_infant" class="room-modal-order__checkbox">
                    <span :title="occupation.ages.infant.src">Добавить в каюту ребенка <SinceTill :agesLine="occupation.ages.infant" /> без места и питания</span>
                </MyCheckbox>
                <div v-else class="room-modal-order__checkbox">
                    В данном круизе бронирование детей возможно <span :title="occupation.ages.infant.src">только с местом</span>
                </div>
            </div>


            <div class="room-modal-order__total room-modal-order__total--forone">
                Базовая стоимость основого места
                <PriceCurrencyV :price="props.CabinSet.baseprice" :sum="false" />
            </div>

            <div v-if="precalc.calc.wait">
                <Loader class="room-modal-order__loader" />
            </div>
            <div v-else-if="precalc.calc && precalc.calc.ok && precalc.calc.acc">
                <div class="room-modal-order__total">
                    Итого: 
                    <PriceCurrencyV :price="precalc.first" :sum="true" />
                </div>
            </div>
            <div v-else>
                {{precalc.calc.ok && !precalc.calc.acc ? `Нельзя добавить каюту: ${precalc.calc.acc_message}` : ''}}
                {{!precalc.calc.ok ? `Не получается добавить каюту, возможно позже: ${precalc.calc.error}` : ''}}
            </div>

            
            <div class="room-modal-order__footer room-modal-footer">
                <template v-if="isBooked() || occupation.mayBook">
                    <div class="room-modal-footer__info">
                        <div class="room-modal-footer__info-text">Конечная стоимость с учетом всех скидок будет рассчитана после бронирования</div>
                        <button
                            v-if="isBooked()"
                            @click.stop.prevent="remove_click"
                            class="room-modal-footer__remove"
                        >
                            Удалить
                        </button>
                    </div>

                    <div class="room-modal-footer__action">
                        <button
                            @click.stop.prevent="book_click"
                            class="btn btn--bluefigma"
                            :disabled="button_book_disabled()"
                        >
                           {{ button_book_text() }}
                        </button>
                    </div>
                </template>
                <template v-else>
                    <div class="room-modal-footer__stop">
                        На этом круизе нельзя бронировать более чем {{kayut(occupation.max_cabins)}}
                    </div>
                </template>

            </div>

        </div>
    </div>
        
</Modal>
</template>


<script setup>
import './RoomSelector.scss'
import {ref, unref, computed, onMounted, watch, nextTick} from 'vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import PriceCurrencyV from '@/comp/CruiseHead/PriceCurrencyV.vue'
import vRooms from '@/assets/vicons/rooms.vue'
import vRemove from '@/assets/vicons/remove.vue'
import ModalTitle from '@/comp/ModalTitle/ModalTitle.vue'
import Modal  from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import 'animate.css'

import MySlider from '@/comp/MySlider/MySlider.vue'

import MyCheckbox from '@/comp/MyCheckbox/MyCheckbox.vue'
import { numWord } from '@/util.js'

import SinceTill from './SinceTill.vue'

import Loader from '@/comp/Loader/Loader.vue'
import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'


const cstore = useCruiseStore()
const bookCabins = useCabinsStore()

const props = defineProps({
    Cabin : Object,
    CabinSet : Object,
    modalShown: Boolean,
})
const emits = defineEmits( ['input'] )



const wasClick = ref(false) // чтобы modal в vue дереве
const wasSetAfterShown = ref(false)  // отслеживаем если кликнули что-то после открытия
const isModalShown = computed({
    get() {
        return props.modalShown
    },
    set(nov) {
//console.log('isModalShown', nov)        
        emits('input', nov)
    }
})
watch( () => props.modalShown, (newVal, oldVal) => {
    if (newVal) {
        wasClick.value = true
        wasSetAfterShown.value = false
        const {id:cabinId, acc} = props.Cabin
        bookCabins.initBookBoxCabin( { cabinId, acc} )
        bookCabins.initCabinPrecalc( cabinId )
    }
} )


//console.log('props', props)

const occupation = bookCabins.getOccupation( props.Cabin.id )
const precalc = bookCabins.getPrecalc( props.Cabin.id )

const forOne = computed( () => {
    let ret = null
    let {first} = unref( precalc )
    if (first) {
        let {adult, child} = unref( occupation )
        const total = adult + child
        let [sum, cur] = first.v
        const one = Math.round( sum / total)
        ret = {v: [one, cur]}
    }
    return ret
})

const infant_str = computed(() => {
    let v = unref(occupation).infant ? '1' : ''
    return v
})
const set_infant = v => {
    const {id:cabinId} = props.Cabin
    const infant = v ? 1 : 0
    bookCabins.setInfant(  { cabinId, infant } )
    bookCabins.updateCabinPrecalc( cabinId )
    wasSetAfterShown.value = true
}

const occrec = computed({
    get() {
        return unref(occupation).adultChild
    },
    set(adultChild) {
        const {id:cabinId} = props.Cabin
        bookCabins.setOccRec(  { cabinId, adultChild } )
        bookCabins.updateCabinPrecalc( cabinId )
        wasSetAfterShown.value = true
    }
})



const book_click = () => {
    const {id:cabinId} = props.Cabin
    if (!isBooked()) {
        bookCabins.bookUnbook({ cabinId })
    }
    isModalShown.value = false
}

const remove_click = () => {
    const { id: cabinId } = props.Cabin
    if (isBooked()) {
        bookCabins.bookUnbook({ cabinId })
    }
    isModalShown.value = false
}

const isBooked = () => bookCabins.isBooked( props.Cabin.id )

const vzros = (num) => {
    const ret = numWord(num, ['взрослый', 'взрослых', 'взрослых'])
    return ret
}
const rebenok = (num) => {
    const ret = numWord(num, ['ребенок', 'ребенка', 'ребенка'])
    return ret
}
const kayut = (num) => {
    const ret = numWord(num, ['каюту', 'каюты', 'каюты'])
    return ret
}


const accText = computed(() => {
    const acc = props.Cabin.acc
    if (!acc) return ''

    let text = numWord(acc.main, ['место', 'места', 'мест'])
    if (acc.additional) {
        text += ` (+${acc.additional})`
    }
    return text
})

const button_book_text = () => {
    let ret = ''
    if (!isBooked()) {
        ret = 'В корзину'
    } else {
        ret = unref(wasSetAfterShown) ? 'Обновить' : 'Закрыть'
    }
    return ret
}
const button_book_disabled = () => {
    let ret = false
    if (unref(isModalShown) &&  !isBooked()) {
        const {calc} = unref(precalc)
        ret = calc.wait 
            || (calc.ok && !calc.acc) 
            || !calc.ok
    }
    return ret
}


</script>
